import { createAsyncThunk } from "@reduxjs/toolkit";

import request from "service";
import { setAcademicWeeks } from "./academicWeekSlice";
import { IErrorResponse } from "types";
import { IAcademicWeeksCreate } from "../types";

const GetAcademicWeeks = createAsyncThunk("academicWeeks/getAcademicWeeks", async (_, { dispatch }) => {
    const response = await request.get("/academic-week");

    dispatch(setAcademicWeeks(response.data));
    return response.data;
});

const CreateAcademicWeek = createAsyncThunk(
    "create/academicWeek",
    async (payload: IAcademicWeeksCreate, { rejectWithValue }) => {
        try {
            const response = await request.post("/academic-week", payload);
            console.log(response.data);
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            console.log(typedError);
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const EditAcademicWeeks = createAsyncThunk("edit/academicWeeks", async (data: any, { rejectWithValue }) => {
    try {
        const response = await request.post(`/academic-week`, data);

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const DeleteAcademicWeeks = createAsyncThunk("delete/academic/weeks", async (id: number, thunkAPI) => {
    try {
        const response = await request.delete(`/academic-week/${id}`);

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;

        return thunkAPI.rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

export { GetAcademicWeeks, CreateAcademicWeek, DeleteAcademicWeeks, EditAcademicWeeks };
